module.exports = __webpack_public_path__ + "static/media/logo-50-ilaprazol.de2ae86d.png";